// Simple text-based 'Loading...' component.
import React from 'react'
import cn from 'classnames'
import styled from 'react-emotion'
import { themeGet as th } from 'styled-system'

const TextLoader = ({ className, text, fullScreen, style }) => (
  <div className={cn(className, 'loader', { fullScreen })} style={style}>
    {text || 'Loading...'}
  </div>
)

export default styled(TextLoader)`
  text-align: center;
  margin: 0 auto;
  color: ${th('colors.gray')};
  padding: ${th('space.2')}px;

  &.fullScreen {
    margin-top: 150px;
  }
`
